export enum SupplierDetailsTab {
  INFORMATION = 'information',
  COWORKERS = 'coworkers',
  AUTH_TOKENS = 'auth-tokens',
}
